var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 900",
    style: {
      enableBackground: "new 0 0 900 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2965,8314c-481-86-868-442-990-910c-44-169-47-268-42-1579c3-1204,4-1232,24-1325c111-501,467-858,973-976 c66-15,150-18,691-21c560-4,618-3,633,12s16,208,16,2396c0,1622-3,2386-10,2400c-10,18-27,19-613,18C3171,8328,3028,8325,2965,8314 z M3870,5914V3888l-407,5c-375,4-415,6-490,25c-322,83-561,331-628,654c-22,101-22,2589-1,2688c60,281,255,514,518,619 c132,53,193,59,621,60l387,1V5914z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3051,7329c-63-12-159-60-210-105c-105-91-157-220-149-372c4-79,9-100,41-164c47-97,118-168,215-216 c67-33,84-37,171-40c79-3,107,0,160,18c217,73,348,284,311,500C3547,7207,3303,7379,3051,7329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4757,8323c-4-3-7-1087-7-2409c0-2181,1-2402,16-2408c27-10,803-6,899,4c406,46,764,293,959,660 c25,47,58,126,75,175c63,188,61,138,61,1575c0,1147-2,1318-16,1391c-99,521-496,914-1018,1004c-70,12-178,15-526,15 C4960,8330,4760,8327,4757,8323z M5825,6145c156-41,284-160,336-312c33-94,32-232-1-318c-61-158-181-269-335-310 c-250-65-516,86-589,334c-22,76-21,204,4,282C5315,6066,5575,6210,5825,6145z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7493,2776c-155-51-247-200-221-362c16-104,76-186,168-233c125-62,258-46,358,44c75,68,107,139,107,240 c0,95-28,166-91,229C7735,2773,7593,2809,7493,2776z M7670,2630c60-31,93-81,98-149c6-89-32-153-111-186c-134-56-286,73-248,212 c16,62,43,97,93,122C7556,2655,7619,2656,7670,2630z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M790,2465v-306l63,3l62,3l5,193l5,193l145-195l145-196l60,2l60,3v300v300l-62,3l-63,3v-197v-198l-147,197 l-148,197h-62h-63V2465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1790,2465v-305h65h65v305v305h-65h-65V2465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2375,2757c-3-7-4-143-3-302l3-290l63-3l62-3v202v203l150-202l150-202h60h60v305v305h-65h-65l-2-192l-3-192 l-144,192l-143,192h-59C2400,2770,2378,2766,2375,2757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3347,2763c-4-3-7-33-7-65v-58h100h100v-240v-240h65h65v240v240h95h95v65v65h-253 C3467,2770,3350,2767,3347,2763z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4300,2465v-305h235h235v60v60h-175h-175v70v70h160h160v55v55h-160h-160v60v60l173,2l172,3l3,58l3,57h-236 h-235V2465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5265,2757c-3-7-4-143-3-302l3-290l63-3l62-3v203v202l150-202l150-202h60h60v305v305h-65h-65l-2-192l-3-192 l-144,192l-143,192h-59C5290,2770,5268,2766,5265,2757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6320,2466v-306h133c154,0,227,15,293,61c195,134,165,421-54,522c-41,19-69,22-209,25l-163,4V2466z M6647,2621 c84-39,120-146,78-235c-32-66-97-96-211-96h-74v175v175h83C6582,2640,6617,2634,6647,2621z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6018,1889c-139-18-263-83-365-192c-223-240-216-605,17-837c86-87,164-132,276-160c184-47,370-10,522,105 c59,44,136,130,130,145c-2,4-43,41-92,84l-88,77l-27-35c-129-169-390-187-541-36c-22,22-52,63-67,92c-25,48-28,63-28,153 c0,86,3,107,25,150c74,153,257,236,416,190c74-21,144-65,188-118l34-41l44,36c24,19,66,56,93,80l50,45l-39,48 C6436,1833,6226,1915,6018,1889z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1072,1850c-238-63-361-222-308-402c38-133,164-198,499-258c225-40,291-73,291-144c0-49-29-85-92-114 c-54-25-66-27-202-27c-161,0-224,13-343,67c-37,17-69,29-71,27c-12-15-107-192-104-194c10-11,170-69,236-87c110-29,345-36,465-14 c224,42,335,145,345,318c8,143-32,217-155,281c-88,46-164,68-358,107c-169,33-217,49-252,82c-31,29-31,81,1,113c72,72,330,75,530,5 c33-11,63-17,67-13c7,8,79,177,79,187c0,9-153,54-239,70C1345,1876,1165,1874,1072,1850z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1924,1843c3-10,73-259,156-553s153-543,156-552c5-16,21-18,144-18h139l11,38c99,358,199,694,204,682 c3-8,50-172,104-365l98-350l140-3l140-3l159,558c87,307,160,564,163,571c3,9-25,12-122,12h-125l-14-47c-8-27-56-207-107-400 c-52-194-96-353-100-353c-3,0-50,152-104,338c-54,185-107,365-118,400l-19,63l-102-3l-102-3l-117-400c-64-220-117-402-118-405 s-46,159-99,360c-54,201-104,384-110,408l-12,42h-125C1929,1860,1919,1859,1924,1843z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3820,1290V720h130h130l-2,568l-3,567l-127,3l-128,3V1290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4350,1735v-125h180h180v-445V720h125h125v445v445l178,2l177,3v120v120l-482,3l-483,2V1735z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6860,1290V720h120h120v225v225h265h265V945V720h120h120l-2,568l-3,567l-117,3l-118,3v-226v-225h-265h-265v225 v225h-120h-120V1290z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.16184f156bf078d9a5e59bb7c88da78c.svg";
export { ForwardRef as ReactComponent };